import React from "react";
import { Redirect, RouteComponentProps } from "react-router-dom";
import { INITIAL_FORM_STEP } from "./constants";
import get from "lodash/get";
import { useAppContext } from "../../../../lib/appContext";

export const RedirectToFirstStep: React.FC<RouteComponentProps<{
  [param: string]: string;
}>> = props => {
  const { businessUnitConfig } = useAppContext();
  const firstStepId = get(businessUnitConfig, "quote.firstStep", INITIAL_FORM_STEP);
  return props.match.params.stepId ? null : <Redirect to={`/${firstStepId}`} />;
};
